import store from '../store'

export function getTeams() {	
	
	const state = store.getState()
	return state.teams
}

